import { track } from "jiffy-analytics";
import "./digital-assets-sort-form.scss";
import EventClass from "common/utils/ui/event-class";

export class DigitalAssetsSortForm extends EventClass {
  constructor(props) {
    super({
      eventSelector: props.eventSelector,
      event: "change"
    });
  }

  // eslint-disable-next-line class-methods-use-this
  event(event) {
    const $form = event.target.form;
    const { activeFilters, resultCount, pageName } = $form.dataset;

    track("digital_asset_sorted", {
      sort_type: event.target.value,
      active_filters: activeFilters,
      result_count: resultCount,
      page_name: pageName
    });

    $form.submit();
  }
}

export default () =>
  new DigitalAssetsSortForm({ eventSelector: ".js-digital-assets-sort-form-select" });
